import * as React from 'react';
import { useTheme } from '../theme';
import { BaseButton } from '../BaseComponents';
import { timeIcon } from '../PaymentTimeLimit/Icons';

interface Props {
	onClick?: () => void;
	title?: string;
	text?: string;
	buttonText?: string;
}

const PaymentTimeLimitPage: React.FC<Props> = ({ onClick, title, text, buttonText }) => {
	const theme = useTheme('PaymentTimeLimit').PaymentTimeLimitPage;

	return (
		<div className={theme.wrapper}>
			<div className={theme.timeImage}>{timeIcon}</div>
			<div className={theme.text}>
				<span>{title}</span>
				<span>{text}</span>
			</div>

			<BaseButton className={theme.button} variant="action" onClick={onClick}>
				{buttonText}
			</BaseButton>
		</div>
	);
};

export default PaymentTimeLimitPage;
